<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <div class="form__item">
                    <i class="form__icon icons icon-magnifier"></i>
                    <vue-select label="title" :options="surveyTemplates" v-model="survey.template" class="form__select" :class="{ 'has-value': survey.template }" >
                        <template slot="no-options">{{$t('forms.common.no_results')}}</template>
                    </vue-select>
                    <label class="form__label">{{$t('forms.survey.template')}}</label>
                </div>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch} from 'vue-property-decorator';
    import Survey from '@/models/Survey';

    import { GET_SURVEY_TEMPLATES } from '@/store/modules/survey-templates';

    @Component
    export default class SurveyForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: Survey, default() {
            return new Survey();
        } })
        survey;

        created() {
            this.errors = [];
            this.$store.dispatch(GET_SURVEY_TEMPLATES, {});
        }

        get isSaveDisabled() {
            return !this.survey.template;
        }

        saveLoading = false;

        get surveyTemplates() {
            return this.$store.state.survey_templates.templates;
        }

        get loading () {
            return this.saveLoading || this.$store.state.survey_templates.loading;
        }

        save() {
            this.errors = [];
            this.saveLoading = true;
            this.survey.survey_template_id = this.survey.template.id;
            this.survey.answers = [];
            this.survey.save()
                .then(res => this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/dashboard/SurveyForm.vue